import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { TripCategory } from "redmond";

export const useChfarFlightsParams = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const itineraryId = params.get("itineraryId");
  const contractId = params.get("contractId");
  const flightShopType = params.get("flightShopType");

  const origin = params.get("origin");
  const departureDate = params.get("departureDate");
  const originRegionType = params.get("originRegionType");
  const destination = params.get("destination");
  const returnDate = params.get("returnDate");
  const destinationRegionType = params.get("destinationRegionType");
  const tripCategory = returnDate
    ? TripCategory.ROUND_TRIP
    : TripCategory.ONE_WAY;

  return useMemo(
    () => ({
      itineraryId,
      contractId,
      origin,
      departureDate,
      originRegionType,
      destination,
      returnDate,
      destinationRegionType,
      tripCategory,
      flightShopType,
    }),
    [
      itineraryId,
      contractId,
      origin,
      departureDate,
      originRegionType,
      destination,
      returnDate,
      destinationRegionType,
      tripCategory,
      flightShopType,
    ]
  );
};
